import MyProfileImg from '@/components/my/common/item/MyProfileImg';
import StarRankMobileSwiperDetailMenu from '@/components/starrank/menu/StarRankMobileSwiperDetailMenu';
import {
  goToChannelViaAppScheme,
  goToLiveViaAppScheme,
} from '@/components/starrank/mobile/StarRankMobileLayout';
import {SoopUiImg} from '@/components/ui';
import classNames from 'classnames';
import {useEffect, useState} from 'react';

/**
 * 별별랭킹 페이지 스와이퍼 영역 내부 슬라이드 아이템 컴포넌트 (모바일)
 */
const StarRankMobileSwiperItem = ({broadItem}) => {
  const [isError, setIsError] = useState(false);

  const [thumbClass, setThumbClass] = useState('');

  const handleLiveImageError = () => {
    setIsError(true);
  };

  useEffect(() => {
    const isAdult = Number(broadItem?.broadGrade) === 19;

    // TODO: 클래스 설정은 하고 있지만 레이아웃 깨짐 문제로 적용은 보류 중
    setThumbClass(
      classNames({
        'thumb-adult': isAdult,
        'thumb-default': isError,
        'thumbs-box': !isAdult & !isError,
      }),
    );
  }, [isError, broadItem?.broadGrade]);

  /**
   * 방송 클릭 시 이벤트, 방송으로 이동 (웹뷰 적용)
   * @param {*} streamerId
   * @param {*} broadcastId
   */
  const onClickLiveBroad = (streamerId, broadcastId) => {
    goToLiveViaAppScheme(streamerId, broadcastId);
  };

  return (
    <>
      <a
        onClick={() => onClickLiveBroad(broadItem?.userId, broadItem?.broadNo)}
        className={`thumbs-box`}>
        {(Number(broadItem.subscriptionOnly) === 1 ||
          Number(broadItem.subscriptionOnly) === 2) && (
          <em class='_subscribe plus'>
            <span>구독</span>
          </em>
        )}
        <SoopUiImg
          src={broadItem?.snUrl}
          onError={handleLiveImageError}
          isAdult={Number(broadItem?.broadGrade) === 19}
          alt='broadcast-thumbnail'
        />
      </a>
      <div className='info'>
        <a
          onClick={() => goToChannelViaAppScheme(broadItem?.userId)}
          className='thumb'>
          <MyProfileImg userId={broadItem?.userId} disableLazy={true} />
        </a>
        <h3>
          <a
            onClick={() =>
              onClickLiveBroad(broadItem?.userId, broadItem?.broadNo)
            }
            className='title'>
            {broadItem?.broadTitle}
          </a>
        </h3>
        <StarRankMobileSwiperDetailMenu rankItem={broadItem} />
      </div>
    </>
  );
};

export default StarRankMobileSwiperItem;
